/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

document.documentElement.style.setProperty('--primary-color', environment.primaryColor);
document.documentElement.style.setProperty('--primary-color-light', environment.primaryColorLight);
document.documentElement.style.setProperty('--primary-color-dark', environment.primaryColorDark);
